import palmLineChange from './actions/palmLineChange';
import palmLineCreate from './actions/palmLineCreate';
import palmLineDetail from './actions/palmLineDetail';
import palmLinesList from './actions/palmLinesList';
import getPalmLines from './getters/getPalmLines';
import palmLinesUpload from './mutations/palmLinesUpload';

const actions = {
    palmLineChange,
    palmLineCreate,
    palmLineDetail,
    palmLinesList
};

const mutations = {
    palmLinesUpload
};

const getters = {
    getPalmLines
};

export default { actions, mutations, getters };
